/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_ParticipantBrokerAccountDTO } from '../models/PagedResultDto_ParticipantBrokerAccountDTO';
import type { Wealthlane_CustomerService_Dtos_Company_CompanyBrokerDto } from '../models/Wealthlane_CustomerService_Dtos_Company_CompanyBrokerDto';
import type { Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_BrokerAccountDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_BrokerAccountDto';
import type { Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_BrokerStatusDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_BrokerStatusDto';
import type { Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_CompanyListDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_CompanyListDto';
import type { Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_ParticipantListDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_ParticipantListDto';
import type { Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_ParticipantListRequestDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_ParticipantListRequestDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantBrokerAccountService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_Company_CompanyBrokerDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantBrokerAccountCurrentCompanyBroker(): CancelablePromise<Wealthlane_CustomerService_Dtos_Company_CompanyBrokerDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-broker-account/current-company-broker',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyIds
     * @param participantIds
     * @param countryIds
     * @param stateIds
     * @param brokerStatusIds
     * @param isOnboarded
     * @param brokerIds
     * @param filter
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns PagedResultDto_ParticipantBrokerAccountDTO OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantBrokerAccountParticipantList(
        companyIds?: Array<string>,
        participantIds?: Array<string>,
        countryIds?: Array<string>,
        stateIds?: Array<string>,
        brokerStatusIds?: Array<number>,
        isOnboarded?: boolean,
        brokerIds?: Array<string>,
        filter?: string,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<PagedResultDto_ParticipantBrokerAccountDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-broker-account/participant-list',
            query: {
                'CompanyIds': companyIds,
                'ParticipantIds': participantIds,
                'CountryIds': countryIds,
                'StateIds': stateIds,
                'BrokerStatusIds': brokerStatusIds,
                'IsOnboarded': isOnboarded,
                'BrokerIds': brokerIds,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppParticipantBrokerAccountExportParticipatList(
        requestBody?: Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_ParticipantListRequestDto,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/participant-broker-account/export-participat-list',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_CompanyListDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantBrokerAccountCompanyList(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_CompanyListDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-broker-account/company-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyIds
     * @returns Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_ParticipantListDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantBrokerAccountParticipants(
        companyIds?: Array<string>,
    ): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_ParticipantListDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-broker-account/participants',
            query: {
                'CompanyIds': companyIds,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_BrokerStatusDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantBrokerAccountBrokerStatusList(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_BrokerStatusDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-broker-account/broker-status-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyIds
     * @param brokerStatusIds
     * @param brokerIds
     * @returns Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_BrokerAccountDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantBrokerAccountAccountOpeningDashboard(
        companyIds?: Array<string>,
        brokerStatusIds?: Array<number>,
        brokerIds?: Array<string>,
    ): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_BrokerAccountDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-broker-account/account-opening-dashboard',
            query: {
                'CompanyIds': companyIds,
                'BrokerStatusIds': brokerStatusIds,
                'BrokerIds': brokerIds,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
